import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Modal } from "../../../components/modals/Modal";
import { emailProviders } from "../constants/constant";
import InputField from "../../../components/formElements/InputField";
import CloseIcon from "@mui/icons-material/Close";
import { memo, useEffect, useState } from "react";

export const EmailConfigModal = memo(
  ({
    open,
    value = {
      smtp_hostname: "",
      smtp_ports: [],
      smtp_port: "",
      email: "",
      username: "",
      password: "",
    },
    onClose,
    onApply,
  }) => {
    const [data, setData] = useState({
      smtp_hostname: "",
      smtp_port: "",
      email: "",
      username: "",
      password: "",
      smtp_ports: [],
      newPassword: false,
      isUserName: false,
      errorStatus: {},
      errorFields: {},
    });

    const validate = () => {
      const errors = {};
      const errorStatus = {};

      // Validate smtp_hostname
      if (!data.smtp_hostname?.trim()) {
        errors.smtp_hostname = "Host name is required";
        errorStatus.smtp_hostname = true;
      }

      // Validate smtp_port
      if (!data.smtp_port?.toString()?.trim()) {
        errors.smtp_port = "SMTP port is required";
        errorStatus.smtp_port = true;
      }

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!data.email?.trim()) {
        errors.email = "Email is required";
        errorStatus.email = true;
      } else if (!emailRegex.test(data.email)) {
        errors.email = "Invalid email format";
        errorStatus.email = true;
      }

      // Validate username
      if (!data.username?.trim()) {
        errors.username = "Username is required";
        errorStatus.username = true;
      }

      // Validate password
      if (!data.password?.trim()) {
        errors.password = "Password is required";
        errorStatus.password = true;
      }

      setData((prev) => ({
        ...prev,
        errorFields: errors,
        errorStatus: errorStatus,
      }));

      return Object.keys(errors).length === 0;
    };
    const handleChange = (e) => {
      let { name, value } = e.target;
      if (name === "password" && value.length) {
        if (data.newPassword == false) {
          value =
            value.length > data.password?.length
              ? value.replace(data.password, "")
              : "";
        }
        setData((prev) => ({
          ...prev,
          [name]: value,
          newPassword: true,
          errorFields: {
            ...prev.errorFields,
            [name]: "",
          },
          errorStatus: {
            ...prev.errorStatus,
            [name]: false,
          },
        }));
      } else {
        setData((prev) => ({
          ...prev,
          [name]: value,
          errorFields: {
            ...prev.errorFields,
            [name]: "",
          },
          errorStatus: {
            ...prev.errorStatus,
            [name]: false,
          },
        }));
      }
    };

    function handleProviderChange(event, newValue) {
      if (newValue) {
        const selectedProvider = emailProviders?.find(
          (p) => p.label === newValue.label
        );

        setData((prev) => ({
          ...prev,
          smtp_hostname: newValue.label || newValue,
          smtp_ports: selectedProvider
            ? [selectedProvider.tlsPort, selectedProvider.sslPort]?.filter(
                Boolean
              )
            : [],
          smtp_port: "",
          errorStatus: {
            ...prev.errorStatus,
            smtp_hostname: false,
          },
          errorFields: {
            ...prev.errorFields,
            smtp_hostname: "",
          },
        }));
      } else {
        setData((prev) => ({
          ...prev,
          smtp_hostname: "",
          smtp_ports: [],
          smtp_port: "",
        }));
      }
    }

    useEffect(() => {
      if (value && open) {
        const {
          smtp_hostname = "",
          smtp_ports = [],
          smtp_port = "",
          email = "",
          username = "",
          password = "",
        } = value;
        setData((prev) => ({
          ...prev,
          smtp_hostname,
          smtp_ports,
          smtp_port,
          email,
          username,
          password,
        }));
      }
      return () => {};
    }, [open, value]);

    const handleClose = () => {
      const {
        smtp_hostname,
        smtp_ports,
        smtp_port,
        email,
        username,
        password,
        newPassword,
      } = data;
      onClose({
        smtp_hostname,
        smtp_ports,
        smtp_port,
        email,
        username,
        password,
        newPassword,
      });
    };

    const handleApply = () => {
      if (validate()) {
        const {
          smtp_hostname,
          smtp_ports,
          smtp_port,
          email,
          username,
          password,
          newPassword,
        } = data;
        onApply({
          smtp_hostname,
          smtp_ports,
          smtp_port,
          email,
          username,
          password,
          newPassword,
        });
      }
    };


      useEffect(() => {
        const handleKeyDown = (event) => {
          // For Windows/Linux: Ctrl+S
          // For Mac: Meta+S (Cmd+S)
          if ((event.ctrlKey || event.metaKey) && event.key === 's' && open) {
            event.preventDefault(); // Prevent the browser's default "save page" behavior
            handleApply()
          }
        };
    
        window.addEventListener('keydown', handleKeyDown);
    
        // Cleanup when component unmounts
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
      }, [data]);

    return (
      <Modal open={open}>
        <Box
          sx={{
            backgroundColor: "primary.main",
            padding: "5px 15px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                color: "#fff",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              Configure
              <IconButton aria-label="delete" onClick={handleClose}>
                <CloseIcon sx={{ color: "#fff" }} />
              </IconButton>
            </Typography>
          </Box>
        </Box>
        <Modal.Body>
          <Box
            sx={{
              padding: "10px",
              gap: "10px",
              display: "flex",
              "flex-direction": "column",
              minWidth: "300px",
            }}
          >
            {/* <InputField
              size={"small"}
              name={"smtp_hostname"}
              value={data?.smtp_hostname}
              onChange={handleChange}
              placeholder={"Host Name"}
              state={data}
            ></InputField> */}

            <Box sx={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                options={emailProviders}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option.label
                }
                onChange={handleProviderChange}
                value={
                  emailProviders.find(
                    (provider) => provider.label === data?.smtp_hostname
                  ) ||
                  (data?.smtp_hostname ? { label: data.smtp_hostname } : null)
                }
                // value={data.smtp_hostname}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="smtp_hostname"
                    label="Host Name"
                    variant="outlined"
                    onChange={handleChange}
                    InputLabelProps={{
                      sx: {
                        // fontSize: '13px',
                        top: data?.smtp_hostname ? "0px" : "-2px",
                      },
                    }}
                  />
                )}
              />

              <Typography
                sx={{
                  marginTop: "2px",
                  marginLeft: "10px",
                  marginBottom: "0px",
                  fontSize: "11px",
                  color: "danger.main",
                  // minHeight: "16px",
                }}
              >
                {data?.errorFields?.smtp_hostname}
              </Typography>
            </Box>

            <Box sx={{ width: "100%" }}>
              <Autocomplete
                freeSolo
                options={data?.smtp_ports}
                getOptionLabel={(option) => option?.toString()}
                onChange={(event, newValue) => {
                  setData((prev) => ({
                    ...prev,
                    smtp_port: newValue || "",
                    errorFields: {
                      ...prev.errorFields,
                      smtp_port: "",
                    },
                    errorStatus: {
                      ...prev.errorStatus,
                      smtp_port: false,
                    },
                  }));
                }}
                value={data?.smtp_port}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="SMTP Port"
                    variant="outlined"
                    name="smtp_port"
                    onChange={handleChange}
                    InputLabelProps={{
                      sx: {
                        fontSize: "13px",
                        top: data?.smtp_port ? "0px" : "-2px",
                      },
                    }}
                  />
                )}
              />

              <Typography
                sx={{
                  marginTop: "2px",
                  marginLeft: "10px",
                  marginBottom: "0px",
                  fontSize: "11px",
                  color: "danger.main",
                  // minHeight: "16px",
                }}
              >
                {data?.errorFields?.smtp_port}
              </Typography>
            </Box>

            <InputField
              size={"small"}
              name={"email"}
              value={data?.email}
              onChange={handleChange}
              onBlur={(e) => {
                if (!data?.isUserName) {
                  setData((prev) => ({
                    ...prev,
                    username: e.target.value,
                    errorFields: prev.errorFields
                      ? { ...prev?.errorFields, username: "" }
                      : {},
                    errorStatus: prev.errorStatus
                      ? { ...prev?.errorStatus, username: false }
                      : {},
                  }));
                }
              }}
              placeholder={"Email"}
              state={data}
              sx={{ width: "100%" }}
            ></InputField>
            <InputField
              size={"small"}
              name={"username"}
              value={data?.username}
              onChange={(e) => {
                handleChange(e);
                setData((prev) => ({
                  ...prev,
                  isUserName: true,
                }));
              }}
              // onBlur={() =>
              //   setData((prev) => ({
              //     ...prev,
              //     isUserName: true,
              //   }))
              // }
              placeholder={"User Name"}
              state={data}
              sx={{ width: "100%" }}
            ></InputField>
            <InputField
              size={"small"}
              name={"password"}
              value={data?.password}
              onChange={handleChange}
              placeholder={"Password"}
              state={data}
              type={data?.newPassword ? "password" : "text"}
              sx={{ width: "100%" }}
            ></InputField>
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Box sx={{ display: "flex", justifyContent: "end", padding: "5px" }}>
            <Button onClick={handleApply} variant={"contained"}>
              {" "}
              Apply
            </Button>
          </Box>
        </Modal.Footer>
      </Modal>
    );
  }
);
